import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuthContext } from '../../contexts/AuthContext';
import { useSystemAdminRegister, useSystemAdminRegisterAvailable } from '../../hooks/queries/authQueries';
import { useUpdateRoleFeatureClaims } from '../../hooks/queries/roleFeatureQueries';
import './Login.css';
import logo from '../../assets/logo.svg';
import loginBackground from '../../assets/images/loginbackground2.svg'
import EyeIcon from '../../assets/icons/eye.svg?react';
import EyeOffIcon from '../../assets/icons/eye-off.svg?react';
import { ROUTES } from '../../utils/constants';
import { Navigate } from 'react-router-dom';
const SystemLogin = () => {
  const { data: systemAdminStatus, isLoading: isCheckingSystemAdmin } = useSystemAdminRegisterAvailable();
  
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const { login, loading, error: authError } = useAuthContext();
  const { mutate: registerSystemAdmin, isPending: isRegistering } = useSystemAdminRegister();
  const { mutate: updateRoleFeatureClaims, isPending: isUpdatingRoleFeature } = useUpdateRoleFeatureClaims();
  const navigate = useNavigate();
  
  // 시스템 관리자 역할에 대한 기능 권한 목록
  const systemAdminFeatures = [
    "AI_MODULE_MANAGEMENT",
    "CBL_MODULE_MANAGEMENT",
    "CHARGER_MANAGEMENT",
    "DASHBOARD",
    "DR_HISTORY",
    "DR_MANAGEMENT",
    "MAP_DASHBOARD",
    "OPM_DATA_LINKAGE_STATUS",
    "REPORT_MANAGEMENT",
    "STATION_MANAGEMENT",
    "SYSTEM_ALERT_HISTORY",
    "SYSTEM_CONFIG_KEY_MANAGEMENT",
    "SYSTEM_LOG",
    "SYSTEM_RECOVERY_COMMAND",
    "SYSTEM_SETTING",
    "USER_ROLE_MANAGEMENT"
  ];

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError(''); // 입력 시 에러 메시지 초기화
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!formData.email || !formData.password) {
      setError('이메일과 비밀번호를 모두 입력해주세요.');
      return;
    }

    // 시스템 관리자 등록
    registerSystemAdmin(
      { email: formData.email, password: formData.password },
      {
        onSuccess: async (data) => {
          // 등록 성공 후 역할-기능 권한 설정
          updateRoleFeatureClaims(
            {
              roleName: "SystemAdmin",
              featureNames: systemAdminFeatures
            },
            {
              onSuccess: async () => {
                // 역할-기능 권한 설정 성공 후 자동 로그인
                try {
                  const result = await login(formData);
                  if (result.success) {
                    navigate('/'); // 로그인 성공 시 메인 페이지로 이동
                  } else {
                    setError(result.error || '로그인에 실패했습니다.');
                  }
                } catch (error) {
                  setError('로그인 중 오류가 발생했습니다.');
                }
              },
              onError: (error) => {
                setError(error?.response?.data?.message || '역할-기능 권한 설정에 실패했습니다.');
              },
            }
          );
        },
        onError: (error) => {
          setError(error?.response?.data?.message || '시스템 관리자 등록에 실패했습니다.');
        },
      }
    );
  };
  if (systemAdminStatus?.status === false) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }
  return (
    <div className="system-login-container">
      <img src={loginBackground} alt="login background" className="absolute top-0 left-0 w-full h-full object-cover z-0" />
      <div className='system-login-form-wrapper z-10'>
        <div className="system-login-form-container">
          <div className="login-header">
            <img src={logo} alt="logo" className="w-16 h-16" />
            <pre className="text-h1 text-gray-900 text-center mt-10">{`한국동서발전\n전기차 충전모니터링 시스템`}</pre>
          </div>
          <p className="text-h2 text-gray-700 text-center my-30">초기 시스템 관리자 계정 생성</p>
          
          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label htmlFor="email">이메일</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="이메일을 입력해주세요"
                className="w-full input-primary big-input"
                required
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="password">비밀번호</label>
              <div className="relative">
                <input
                type={showPassword ? "text" : "password"}
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="비밀번호를 입력해주세요"
                className="w-full input-primary big-input"
                  required
                />
                <button type="button" className="password-toggle-btn" onClick={(e) => {
                  e.preventDefault();
                  setShowPassword(!showPassword);
                }}>
                  {showPassword ? <EyeOffIcon color="var(--gray-800)" /> : <EyeIcon color="var(--gray-800)" />}
                </button>
              </div>
            </div>
            
            {(error || authError) && (
              <div className="error-message">
                {error || authError}
              </div>
            )}
            
            <button 
              type="submit" 
              className="login-button"
              disabled={loading || isRegistering || isUpdatingRoleFeature}
            >
              {isRegistering ? '등록 중...' : isUpdatingRoleFeature ? '권한 설정 중...' : loading ? '로그인 중...' : '시스템 관리자 등록'}
            </button>
          </form>
        </div>
      </div>
      
    </div>
  );
};

export default SystemLogin;